import React, { Component } from 'react';

// コンポーネント読み込み
import Navigation from '../components/Navigation'

class Home extends Component {
  render() {
    return (
      <div className="Home">
        <div>観光スポットスタンプラリーとは...</div>
        <div>スタンプラリー感覚で観光スポットをめぐることができるサービスです</div>
        <div>以下のチュートリアルに従って観光スポットを巡って行きましょう</div>
        <Navigation />
      </div>
    );
  }
}

export default Home;
